import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len, react/prop-types */
var Spotify = function Spotify(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 20 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 21 : _ref$height;
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    className: className,
    height: height,
    role: "presentation",
    viewBox: "0 0 20 21",
    width: width,
    children: [/*#__PURE__*/_jsx("title", {
      children: "Spotify"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M15.9 9.386C12.7 7.498 7.35 7.299 4.3 8.243c-.5.15-1-.149-1.15-.596-.15-.497.15-.994.6-1.143 3.55-1.043 9.4-.844 13.1 1.342.45.248.6.844.35 1.292-.25.347-.85.496-1.3.248m-.1 2.782c-.25.348-.7.497-1.05.249-2.7-1.64-6.8-2.137-9.95-1.143-.4.1-.85-.1-.95-.497-.1-.397.1-.845.5-.944C8 8.74 12.5 9.287 15.6 11.175c.3.149.45.645.2.993m-1.2 2.733c-.2.298-.55.397-.85.199-2.35-1.441-5.3-1.74-8.8-.944-.35.099-.65-.15-.75-.447-.1-.348.15-.646.45-.746 3.8-.844 7.1-.497 9.7 1.093.35.15.4.547.25.845M10 .542c-5.5 0-10 4.472-10 9.937 0 5.465 4.5 9.937 10 9.937s10-4.472 10-9.937C20 5.014 15.55.542 10 .542"
    })]
  });
};

export default Spotify;